import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../../../core/auth/_models/user.model';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'kt-user-detail-dialog',
  templateUrl: './user-detail-dialog.component.html',
  styleUrls: ['./user-detail-dialog.component.scss']
})
export class UserDetailDialogComponent implements OnInit {
  user: any; // Define a variable to hold the user data

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private router: Router,private activatedRoute: ActivatedRoute,
  private dialogRef: MatDialogRef<UserDetailDialogComponent>) { }

  ngOnInit(): void {
    this.user = this.data.user; // Assign the user data passed from the parent component
  }
  handleImageError(user: User) {
		// If there's an error loading the image or the profilePicture is not available
		if (!user.profilePicture) {
			// Set a default image URL using the user's full name
			user.profilePicture = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.fullname.charAt(0)) + '&background=random';
		}
	}
  editUser(id: string) {
    this.router.navigate(['/user-management/users/edit', id]).then(() => {
      this.dialogRef.close(); // Close the dialog after navigation
    });
}
}
